<div class="help-popover-wrapper turn-around" [ngClass]="styleClass">
  <div class="content" [ngClass]="displayType">
    <span *ngFor="let text of helpText">
      <p [innerHTML]="text" class="turn-around"></p>
    </span>
  </div>
</div>
